import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const segmentedControlDefaultVariants = {}
const segmentedControlCompoundVariants = []

const segmentedControlSlotNames = [
  [
    "root",
    "SegmentedControl__root"
  ],
  [
    "segment",
    "SegmentedControl__segment"
  ]
]
const segmentedControlSlotFns = /* @__PURE__ */ segmentedControlSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, segmentedControlDefaultVariants, getSlotCompoundVariant(segmentedControlCompoundVariants, slotName))])

const segmentedControlFn = memo((props = {}) => {
  return Object.fromEntries(segmentedControlSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const segmentedControlVariantKeys = []
const getVariantProps = (variants) => ({ ...segmentedControlDefaultVariants, ...compact(variants) })

export const segmentedControl = /* @__PURE__ */ Object.assign(segmentedControlFn, {
  __recipe__: false,
  __name__: 'segmentedControl',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: segmentedControlVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, segmentedControlVariantKeys)
  },
  getVariantProps
})